import { render, staticRenderFns } from "./TypeTopic.vue?vue&type=template&id=0d310eda&"
import script from "./TypeTopic.vue?vue&type=script&lang=js&"
export * from "./TypeTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports